export default __webpack_public_path__ + "static/share-brandpage-url@2x-e3b53d405ab68498ec619518923bb919.png";